export default __webpack_public_path__ + "static/media/cog.17d93f98.svg";